import React from 'react';
import { Navigate } from 'react-router-dom';

// Redirect to the interactive workbook homepage
const Workbook: React.FC = () => {
  return <Navigate to="/elevation/workbook/home" replace />;
};

export default Workbook;

